import {FileDataSource, Stream, DataSource, Track} from "../../../types/dataSourceTypes";
import React, {useEffect, useState} from "react";
import Grid from "@mui/material/Grid";
import {FormControl, FormControlLabel, FormLabel, Radio, SelectChangeEvent, Typography} from "@mui/material";
import TextinputField from "../../CommonComponents/TextInputField/TextinputField";
import StyledTextarea from "../../CommonComponents/StyledTextarea/StyledTextarea";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import StyledDataTimePicker from "../../CommonComponents/StyledDateTimePicker/StyledDataTimePicker";
import dayjs, {Dayjs} from "dayjs";
import StyledAutocomplete from "../../CommonComponents/StyledAutocomplete/StyledAutocomplete";
import Box from "@mui/material/Box";
import {useTheme} from "../../../contexts/theme";
import StyledDropdown from "../../CommonComponents/StyledDropdown/StyledDropdown";
import Tracksform from "./Tracksform";
import {formatLabel} from "../../../utils/utils";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import TransparentButton from "../../CommonComponents/TransparentButton/TransparentButton";
import StyledRadioGroup from "../../CommonComponents/StyledRadioGroup/StyledRadioGroup";



interface StreamDataSourceFormProps {
    stream?: Stream;
    protocol?: string[];
    typeMediaTrack?: string[];
    name?: string;
    description?: string;
    updateStreamDataSource: (nameDS:  keyof Stream,  value: string | Dayjs | boolean) => void;
    displayUrl?: boolean;
    displayNameAndDescription?: boolean;
    needPadding?: boolean;
    handleTrackChange: (field: keyof Track, value: string | null, indexTrack : number) => void;
}




export default function StreamDataSourceForm ({needPadding = true, displayUrl, stream, protocol, updateStreamDataSource, typeMediaTrack, displayNameAndDescription, handleTrackChange}: StreamDataSourceFormProps) {

    const theme = useTheme();


    const handleStreamChange = (name:  keyof Stream, event: React.ChangeEvent<HTMLInputElement> | SelectChangeEvent<string>, indexTrack?: number ) => {
        let value: string | boolean = event.target.value;
        if (name === 'pushPullButton'){
            value = event.target.value === 'Push';
        }

        updateStreamDataSource(name, value);
    }

    const handleDateChange = (name: keyof Stream,newValue: Dayjs | null) => {
        if (newValue) {
            updateStreamDataSource(name, newValue);
        }
    }

    const addTrack = () => {
        handleTrackChange("typeTrack",null,stream!.tracks.length);
    }

    const removeTRack = (idTrack: number) => {
        handleTrackChange("idTrack",null,idTrack);
    }

    useEffect(() => {
        if (stream?.pushPullButton)
        updateStreamDataSource('url', "");
    }, [stream?.pushPullButton]);



    return (
        <Box sx={{
            width: '100%',
            alignItems: 'center',
            justifyContent: 'center',
        }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                        <FormControl fullWidth={true}>
                            {displayNameAndDescription &&  <TextinputField placeholder='name' label={'Name'} type='text' variant={'outlined'}
                                            value={stream?.name}
                                            size={'medium'}
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {handleStreamChange('name',event)}}
                                            name={'name'}
                                            id={"outlined-basic"}
                                            borderBottomColor={theme.palette.orange} marginBottom={theme.spacing.md}
                                            backgroundColor={'none'}
                                            color={theme.palette.white}
                                            borderColor={theme.palette.white}
                                            borderRadius={theme.border.width.hard}

                            ></TextinputField> }

                            {displayNameAndDescription && <TextinputField placeholder='description' label={'Description'} type='text' variant={'outlined'}
                                            value={stream?.description}
                                            size={'medium'}
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {handleStreamChange('description',event)}}
                                            name={'description'}
                                            id={"outlined-basic"}
                                            borderBottomColor={theme.palette.orange} marginBottom={theme.spacing.md}
                                            backgroundColor={'none'}
                                            color={theme.palette.white}
                                            borderColor={theme.palette.white}
                                            borderRadius={theme.border.width.hard}

                            ></TextinputField> }

                        </FormControl>

                        <FormControl fullWidth={true}>
                            {displayUrl && <TextinputField placeholder='Url' label={'Url'} type='text' variant={'outlined'} disabled={stream?.pushPullButton}
                                            value={stream?.url}
                                            size={'medium'}
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {handleStreamChange('url',event)}}
                                            name={'name'}
                                            id={"outlined-basic"}
                                            borderBottomColor={theme.palette.orange} marginBottom={theme.spacing.md}
                                            backgroundColor={'none'}
                                            color={theme.palette.white}
                                            borderColor={theme.palette.white}
                                            borderRadius={theme.border.width.hard}

                            ></TextinputField>}

                        </FormControl>


                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
                                <FormControl fullWidth={true}>
                                    {protocol &&
                                        <StyledDropdown
                                            options={protocol}
                                            label="Select the protocol"
                                            id='outlined' value={stream?.protocol}
                                            onChange={(event: SelectChangeEvent<string>) => {handleStreamChange('protocol', event)}}
                                        /> }
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
                                {(stream?.protocol && (stream?.protocol.includes("srt") || stream?.protocol.includes("rtmp")) ) && (
                                    <Box display="flex" alignItems="flex-end" justifyContent="flex-end">
                                    <FormControl>
                                    <StyledRadioGroup
                                        row={false}
                                        onChange={(event) => handleStreamChange('pushPullButton', event)}
                                        value={stream.pushPullButton != undefined ? stream.pushPullButton ? "Push" : "Pull" : "Pull"}
                                    >
                                        <FormControlLabel value="Push" control={<Radio size={'small'} style={{paddingTop:theme.spacing.xs}} />} label="Push" />
                                        <FormControlLabel value="Pull" control={<Radio size={'small'} style={{paddingTop:theme.spacing.none}} />} label="Pull" />
                                    </StyledRadioGroup>
                                    </FormControl>
                                    </Box>
                                )}
                            </Grid>
                        </Grid>


                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                        <FormControl fullWidth sx={{paddingTop: needPadding ? theme.spacing.md : 0}}>

                            <LocalizationProvider dateAdapter={AdapterDayjs}>

                                <StyledDataTimePicker label={'Start '}
                                                      value={dayjs(stream?.start)}
                                                      borderFocusColor={theme.palette.orange}
                                                      borderColor={theme.palette.white}
                                                      onChange={(value: dayjs.Dayjs | null) => {handleDateChange ('start',value)}}/>

                            </LocalizationProvider>


                            <LocalizationProvider dateAdapter={AdapterDayjs}>

                                <StyledDataTimePicker label={'End '} borderFocusColor={theme.palette.orange}
                                                      value={dayjs(stream?.end)}
                                                      borderColor={theme.palette.white}
                                                      paddingTop={theme.spacing.md}
                                                      onChange={(value: dayjs.Dayjs | null) => {handleDateChange ('end',value)}}/>

                            </LocalizationProvider>


                        </FormControl>


                    </Grid>

                </Grid>

            <Box sx={{
                width: '100%',
                paddingTop: theme.spacing.md,

            }}>
                {displayUrl && stream && stream.tracks && <Box>
                    <Typography
                        variant="h6"
                        gutterBottom
                        sx={{
                            color: theme.palette.white,
                            fontWeight: theme.fontWeights.title,
                        }}
                    >
                        Tracks
                    </Typography>
                    {stream?.tracks.map((row, index)=>(
                        <Box sx={{
                            paddingTop: theme.spacing.md,
                        }}>
                            <Tracksform tracks={row} index={index} handleChangeTrack={handleTrackChange} typeMediaTrack={typeMediaTrack} onRemoveTrack={removeTRack} />
                        </Box>

                    ))}
                    <Box sx={{
                        width: '100%',
                        padding: theme.spacing.md,
                    }}>
                        <Grid container>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <TransparentButton text='Add Track' width='100%' onClick={addTrack} ></TransparentButton>

                            </Grid>
                        </Grid>
                    </Box>
                </Box>}



            </Box>

        </Box>


    );

}